import React, { useEffect, useState } from "react";

export const Footer = () => {
    const [time, setTime] = useState("");
    useEffect(() => {
        const update = () => {
            try {
                const t = new Intl.DateTimeFormat("en-IN", {
                    timeZone: "Asia/Kolkata",
                    hour: "2-digit",
                    minute: "2-digit",
                    hour12: false,
                }).format(new Date());
                setTime(`${t} IST`);
            } catch (_) {
                setTime("");
            }
        };
        update();
        const id = setInterval(update, 30000);
        return () => clearInterval(id);
    }, []);

    return (
        <footer
            data-testid="footer"
            className="border-t-2 border-[var(--ink)] bg-[var(--page)]"
        >
            <div className="mx-auto max-w-[1400px] px-5 md:px-10 py-6 flex flex-wrap items-center justify-between gap-3">
                <div className="mono-meta">
                    © 2025 — Manas Bhansali. Designed &amp; built with care.
                </div>
                <div className="mono-meta flex items-center gap-3">
                    <span>Pune · IN</span>
                    <span className="opacity-40">◆</span>
                    <span>{time || "—"}</span>
                    <span className="opacity-40">◆</span>
                    <a
                        href="#hero"
                        data-scroll-to="hero"
                        className="link-underline"
                    >
                        Back to top ↑
                    </a>
                </div>
            </div>
        </footer>
    );
};
